import React, { useEffect } from 'react';
import Header from './common/header-component/header';
import Sidebar from './common/sidebar-component/sidebar';
import RightSidebar from './common/right-sidebar';
import Footer from './common/footer';
import ThemeCustomizer from './common/theme-customizer'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from './common/loader';
import { useLocation } from 'react-router-dom';

const AppLayout = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        // Restore body scroll
        document.body.style.overflow = '';

        // Clean up any leftover modal overlays
        const overlays = document.querySelectorAll('.custom-modal-overlay');
        overlays.forEach(overlay => {
            overlay.remove();
        });
    }, [location.pathname]);

    return (
        <div>
            <Loader />
            <div className="page-wrapper">
                <div className="page-body-wrapper">
                    <Header />
                    <Sidebar />
                    <RightSidebar />
                    <div className="page-body">
                        {children}
                    </div>
                    <Footer />
                    <ThemeCustomizer />
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}

export default AppLayout;